import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ee',
    fullName: 'Ewe',
    nativeName: 'Eʋegbe',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid ƒe nyawo",
    landing_title: "Nu wɔnuku aɖe le Vava ge",
    landing_subtitle: "ArgVoid nye app kple fefewo wɔwɔ ƒe dɔwɔƒe. Mikpɔ egbɔ, nu yeyewo gbɔna kpuie!",
    select_language: "Tia Gbegbɔgblɔ",
    search_placeholder: "Di gbegbɔgblɔwo...",
    terms_title: "Subɔsubɔdɔ ƒe Ðoɖowo",
    policy_title: "Ameŋunyatakakawo Ŋuti Ðoɖo",
    cookies_title: "Kuki Ŋuti Ðoɖo",
    terms_content: `
        <strong>1. Lɔlɔ̃ ɖe Ðoɖowo dzi</strong><br>
        Ne ège ɖe ArgVoid me la, èlɔ̃ ɖe Subɔsubɔdɔ ƒe Ðoɖo siawo dzi. Ne womelɔ̃ ɖe ɖoɖo siawo dzi o la, mele be woazã subɔsubɔdɔa o.<br><br>

        <strong>2. Nuƒolanɔƒea Zazã</strong><br>
        Wotsɔ ArgVoid kple eƒe dɔwɔɖoɖowo na "abe alesi wòle ene" hena nyatakaka kple nutovɛ ƒe taɖodzinuwo. Ele be woazã subɔsubɔdɔa na taɖodzinu siwo le se nu ko.<br><br>

        <strong>3. Nuwɔna si ŋu wode se ɖo</strong><br>
        Wode se ɖe nyatakakadzraɖoƒea ƒe afɔkuwo zazã, nyatakaka gbegblẽwo ɖoɖo ɖe amewo, alo agbagbadzedze be woage ɖe xɔtuɖoɖoa me si ŋu womeɖe mɔ ɖo o nu vevie.<br><br>

        <strong>4. Adzɔgbeɖeɖe</strong><br>
        Woate ŋu atrɔ asi le nuƒolanɔƒea kple dɔwɔnawo ŋu ɣesiaɣi ɣeyiɣi aɖeke maxɔmaxɔe. Wometsɔ kakaɖedzi aɖeke ku ɖe ɣeyiɣi si woatsɔ awɔ dɔa alo eƒe anyinɔnɔ ŋu o.
    `,
    policy_content: `
        <strong>1. Nyatakakawo Nuƒoƒoƒu</strong><br>
        Nuƒolanɔƒea mehiã be zãla naɖo kpe edzi alo awɔ akɔnta le ɣeyiɣi sia me o. Womexɔa ameŋunyatakaka aɖeke (abe ŋkɔwo alo e-mail adrɛs ene) tso amedzrowo gbɔ vevie o.<br><br>

        <strong>2. Zãzã ƒe Nyatakaka</strong><br>
        Woate ŋu aƒo numekuku vevi siwo womeyɔ o nu ƒu be woase nyatakakadzraɖoƒea ƒe ʋuʋu gɔme eye woana dɔwɔnuawo nanyo ɖe edzi. Nyatakaka sia medo ƒome kple zãla ɖekaɖekawo ƒe dzesidenuwo o.<br><br>

        <strong>3. Ame Etɔ̃lia ƒe Dɔwɔƒewo</strong><br>
        Woate ŋu azã ame etɔ̃lia ƒe dɔwɔƒe siwo naa kpekpeɖeŋu amewo hena amedzroxɔƒe kple numekukudɔwo wɔwɔ. Dɔwɔƒe siawo ƒe ameŋunyatakakawo takpɔkpɔ ƒe nuwɔnawoe kpɔa nyatakaka siwo ŋu ŋkɔ mele o siwo ŋu wotrɔ asi le le woƒe xɔtuɖoɖowo dzi la dzi.<br><br>

        <strong>4. Nyatakakawo ƒe Dedienɔnɔ</strong><br>
        Wowɔa dedienɔnɔ ƒe ɖoɖo siwo sɔ tsɔ kpɔa nuƒolanɔƒea ta. Gake mɔnu aɖeke si dzi woato aɖo nyatakakawo ɖe amewo to Internet dzi la mele dedie bliboe o.<br><br>
    `,
    cookies_content: `
        <strong>1. Nukae nye Kukiwo kple Nutoa me Nudzraɖoƒe?</strong><br>
        Cookies kple browser local storage nye nyatakaka sue siwo wodzra ɖo ɖe mɔ̃a dzi be woaɖo ŋku ɖoɖowɔɖi ƒe didiwo dzi le sasrãkpɔwo katã me.<br><br>

        <strong>2. Zãzã ƒe Taɖodzinu</strong><br>
        Wozãa Browser LocalStorage vevie tsɔ dzraa ɖoɖowɔɖi ƒe ɖoɖowo ɖo, abe:<br> ene
        - Gbegbɔgblɔ ƒe didiwo<br>
        - Zãla ƒe ŋgɔdonya ƒe ɖoɖowɔwɔ (e.g., ɖoɖo alo tanya ƒe ɖoɖowo)<br>
        - Ɣeyiɣi kpui aɖe ƒe dɔwɔwɔ cache<br><br>

        <strong>3. No Tracking</strong><br>
        Womezãa cookies kple nudzraɖoƒe siwo le mia gbɔ hena boblododo alo ame bubuwo ƒe kplɔkplɔ ɖo o. Nyatakaka siwo katã wodzra ɖo la nye na mɔ̃a ƒe dɔwɔwɔ vevitɔ koŋ.<br><br>

        <strong>4. Dziɖuɖu</strong><br>
        Woate ŋu akɔ web-browser ƒe nyatakakawo me ɣesiaɣi to browser ƒe ɖoɖowo dzi, si agbugbɔ aɖo teƒea ƒe ɖoɖo ɖesiaɖe.
    `,
    cookie_consent_text: "Míezãa cookies veviwo tsɔ kpɔa egbɔ be nyatakakadzraɖoƒea le dɔ wɔm nyuie, abe wò ɣeyiɣia ƒe dɔwɔwɔ, gbe si nèdi la dzadzraɖo, kple ɖoɖo bubu siwo nèwɔ ɖe ɖoɖo nu ene.",
    read_policy: "Xlẽ Kuki Ŋuti Ðoɖo",
    support_title: "Te ɖe Kpekpeɖeŋunalawo ŋu",
    support_subject_label: "Nyati",
    support_message_label: "Gbedeasi",
    support_submit_button: "Ðo Gbedasi Ðo",
    support_hint: "De dzesii: Esia aʋu wò e-mail dɔwɔnu si nèzãna tsɔ ɖoa ​​gbedasi la ɖa.",
    support_success_msg: "Wò email app ʋuʋu...",
    support_error_msg: "Do kpo gbedasi ɖoɖo ɖa. Taflatse gadze agbagba ake emegbe.",
    explorer_title: "Explorer",
    history_title: "Nyadzɔdzɔ",
    animation_title: "Nɔnɔmetata siwo me agbe le",
    config_title: "Ðoɖowɔwɔ",
    tool_mouse: "Tia (Ctrl+M) .",
    tool_brush: "Brɔs (Ctrl+B) ƒe .",
    tool_brush_mode: "Toggle Mode (Sesẽ/Kɔ) .",
    tool_eraser: "Nututumɔ̃ (Ctrl+E) .",
    tool_brush_size: "Trɔ Asi Le Brɔs ƒe Agbɔsɔsɔme Ŋu",
    tool_bucket: "Kpee ɖo (Ctrl+F) .",
    tool_eyedropper: "Ŋku ƒe ʋuʋudedi",
    tool_grid: "Grid (Ctrl + Trɔ + B) .",
    tool_rotate: "Trɔ (Ctrl + Trɔ + R) .",
    tool_flip_h: "Trɔ H (Ctrl + Trɔ + H) .",
    tool_flip_v: "Trɔ V (Ctrl + Trɔ + V) .",
    tool_transpose: "Trɔ asi le nu ŋu (Ctrl + Trɔ + T) .",
    label_width: "Kekeme",
    label_height: "Kᴐkᴐme",
    label_frames: "Framewo ƒe Xexlẽme",
    label_animation: "Nɔnɔmetatawo Ƒe Atsyã",
    label_background_color: "Amadede si le megbe",
    label_interval: "Dometsotso",
    tool_anim_config: "Animation ƒe Ðoɖowɔwɔ",
    label_new_width: "Kekeme Yeye",
    label_new_height: "Kɔkɔme Yeye",
    label_apply: "Tsᴐe wᴐ dᴐ",
    label_colors: "Amadedewo",
    label_size: "Lolome",
    label_tolerance: "Dzigbɔɖi",
    val_horizontal: "Si mlɔ anyi",
    val_vertical: "Tsi tsitre",
    val_sequence: "Yomenuwo",
    val_bounce: "Dzodzo",
    val_random: "Si mele ɖoɖonu o",
    val_solid: "Nu sesẽ",
    val_clear: "Me kᴐ",
    action_add_sheet: "Agbalẽvi Yeye",
    action_import: "Dɔ nu",
    action_export: "Ɖoe ɖa",
    action_sort_projects: "Ɖo",
    sort_date_old: "Xoxotɔ Gbãtɔ",
    sort_date_new: "Yeyetɔ Gbãtɔ",
    sort_name_az: "Ŋkɔ (A-Z) .",
    sort_name_za: "Ŋkɔ (Z-A) .",
    action_new_sprite: "Sprite Yeye",
    action_new_project: "Dɔ Yeye",
    modal_save_all_title: "Dzra Tɔtrɔawo Katã ɖo",
    modal_save_all_desc: "Tia nunɔamesi siwo nàdzra ɖo:",
    modal_save_selected: "Dzra Ðo Tiatia",
    action_saved: "Wodzrae ɖo",
    modal_create_sprite_title: "Wɔ Sprite Yeye",
    modal_create_project_title: "Wɔ Dɔ Yeye",
    modal_add_sheet_title: "Tsɔ Agbalẽvi Yeye kpee",
    modal_rename_sheet_title: "Trɔ ŋkɔ na Agbalẽvi",
    modal_rename_sprite_title: "Trɔ ŋkɔ na Sprite",
    modal_delete_sprite_title: "Tsɔ Sprite tutu ɖa",
    modal_delete_project_title: "Tsɔ Dɔa tutu ɖa",
    modal_delete_sheet_title: "Tsɔ Agbalẽvi la Tutu",
    placeholder_sprite_name: "Ŋkɔ",
    placeholder_project_name: "Ŋkɔ",
    placeholder_sheet_name: "Ŋkɔ",
    placeholder_new_name: "Ŋkɔ Yeye",
    action_create: "Wᴐ",
    action_add: "Kpee ɖe eŋu",
    action_rename: "Trɔ ŋkɔa",
    action_duplicate: "Wogbugbɔ ŋlɔe",
    action_delete: "Ɖe ɖa",
    action_cancel: "Te fli ɖe eme",
    confirm_delete_sprite: "Èka ɖe edzi be yedi be yeatutu sprite sia?",
    confirm_delete_project: "Èka ɖe edzi be yedi be yeatutu dɔ sia ɖaa? Woaɖe spritewo katã ɖa.",
    confirm_delete_sheet: "Èka ɖe edzi be yedi be yeatutu agbalẽvi sia ɖaa?",
    err_select_sprite: "Taflatse tia sprite aɖe gbã.",
    err_select_project: "Taflatse tia dɔ aɖe gbã.",
    err_name_empty: "Ŋkɔ mate ŋu anye ƒuƒlu o.",
    err_sprite_exists: "Sprite si xɔ ŋkɔ ma li xoxo.",
    err_project_exists: "Dɔ aɖe si ŋu ŋkɔ ma le li xoxo.",
    err_no_content: "Nyatakaka aɖeke meli woadzra ɖo o.",
    err_no_changes: "Tɔtrɔ aɖeke meli woatsɔ adzrae ɖo o.",
    err_delete_last_sheet: "Mate ŋu atutu agbalẽvi mamlɛtɔ o.",
    err_extract_frames: "Mete ŋu ɖe frame aɖeke ɖa o.",
    err_indexeddb: "Do kpo nu dzraɖo ɖe nutoa me. Ðewohĩ wò web-browser mawɔ dɔ le IndexedDB ŋu o.",
    msg_upload_success: "Upload dzidzedzetɔe: {0}",
    msg_upload_failed: "Wodo kpo nudɔdɔ: {0}",
    msg_save_success: "Dzra ɖo dzidzedzetɔe.",
    msg_saving: "Dzraɖoƒe...",
    msg_multi_save_result: "Wodzra {0} nunɔamesiwo ɖo. {1} kpododonuwo.",
    menu_title: "Menu ƒe nuɖuɖu",
    menu_save: "Dzrae ɖo",
    menu_save_all: "Ðe Wo Katã",
    menu_support: "Te ɖe Kpekpeɖeŋunalawo ŋu",
    label_local_storage: "Nudzraɖoƒe si le Nutoa Me",
    label_sign_in: "De asi ete",
    modal_export_title: "Sprite si woɖo ɖe duta",
    label_filename: "Faɛl ƒe ŋkɔ",
    label_format: "Format",
    action_export_confirm: "Ɖoe ɖa",
};

export default translations;
